/* Filtros de colección: línea, marca, tipo, color, versión y precio */
(() => {
  const root = document.querySelector('[data-fx2]');
  const panel = document.querySelector('[data-fx-panel]');
  if (!root || !panel) return;
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const LIST_KEYS = ['linea', 'marca', 'tipo', 'color', 'anio', 'serie', 'edicion'];
  const KEYS = LIST_KEYS.concat(['stock', 'precio']);

  const items = $$('[data-fx-item]', root).map((el) => {
    const d = { el, stock: el.dataset.stock, precio: Number(el.dataset.precio) || 0 };
    LIST_KEYS.forEach((k) => { d[k] = (el.dataset[k] || '').split(' ').filter(Boolean); });
    return d;
  });
  const opts = $$('[data-fx-key]', panel);
  const state = {};
  KEYS.forEach((k) => { state[k] = new Set(); });

  const params = new URLSearchParams(location.search);
  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) v.split(',').forEach((x) => state[k].add(x));
  });

  const inRange = (price, r) => { const [a, b] = r.split('-').map(Number); return price >= a && price <= b; };
  const passes = (it, k) => {
    const sel = state[k];
    if (!sel.size) return true;
    if (k === 'stock') return it.stock === 'si';
    if (k === 'precio') return [...sel].some((r) => inRange(it.precio, r));
    return it[k].some((v) => sel.has(v));
  };
  const matches = (it, except) => KEYS.every((k) => k === except || passes(it, k));
  const has = (it, k, v) => {
    if (k === 'stock') return it.stock === 'si';
    if (k === 'precio') return inRange(it.precio, v);
    return it[k].includes(v);
  };

  const labelOf = (k, v) => {
    const o = opts.find((b) => b.dataset.fxKey === k && b.dataset.fxVal === v);
    return o ? (o.dataset.fxLabel || o.textContent.trim()) : v;
  };

  const chips = root.querySelector('[data-fx-chips]');
  const empty = root.querySelector('[data-fx-empty]');
  const badge = root.querySelector('[data-fx-badge]');
  const counts = $$('[data-fx-count]');
  const resets = $$('[data-fx-clear]');

  function render() {
    let shown = 0;
    items.forEach((it) => {
      const ok = matches(it);
      it.el.hidden = !ok;
      if (ok) shown += 1;
    });
    counts.forEach((c) => { c.textContent = shown; });
    if (empty) empty.hidden = shown > 0;

    opts.forEach((b) => {
      const k = b.dataset.fxKey;
      const v = b.dataset.fxVal;
      const n = items.filter((it) => matches(it, k) && has(it, k, v)).length;
      const on = state[k].has(v);
      b.setAttribute('aria-pressed', on);
      b.classList.toggle('is-zero', n === 0 && !on);
      const nEl = b.querySelector('[data-fx-n]');
      if (nEl) nEl.textContent = n;
    });

    let active = 0;
    const chipHtml = [];
    KEYS.forEach((k) => state[k].forEach((v) => {
      active += 1;
      chipHtml.push(`<button type="button" class="fx-chip" data-chip-key="${k}" data-chip-val="${v}">${labelOf(k, v)}<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>`);
    }));
    if (chips) {
      chips.hidden = active === 0;
      chips.innerHTML = active ? chipHtml.join('') + `<button type="button" class="fx-chip fx-chip--clear" data-chip-clear>${(window.MisHW && MisHW.strings && MisHW.strings.clearFilters) || 'Quitar filtros'}</button>` : '';
    }
    if (badge) { badge.hidden = active === 0; badge.textContent = active; }
    resets.forEach((r) => { if (r.classList.contains('fx-reset')) r.hidden = active === 0; });
    $$('[data-fx-sel]', panel).forEach((s) => {
      const n = s.dataset.fxSel.split(' ').reduce((a, k) => a + state[k].size, 0);
      s.textContent = n ? n : '';
    });

    const url = new URL(location.href);
    KEYS.forEach((k) => { if (state[k].size) url.searchParams.set(k, [...state[k]].join(',')); else url.searchParams.delete(k); });
    history.replaceState(null, '', url);
  }

  opts.forEach((b) => b.addEventListener('click', () => {
    const s = state[b.dataset.fxKey];
    const v = b.dataset.fxVal;
    if (s.has(v)) s.delete(v); else s.add(v);
    render();
  }));
  const clearAll = () => { KEYS.forEach((k) => state[k].clear()); render(); };
  resets.forEach((r) => r.addEventListener('click', clearAll));
  if (chips) chips.addEventListener('click', (e) => {
    const c = e.target.closest('button');
    if (!c) return;
    if (c.hasAttribute('data-chip-clear')) return clearAll();
    state[c.dataset.chipKey].delete(c.dataset.chipVal);
    render();
  });

  const brandsBox = panel.querySelector('[data-fx-brands]');
  if (brandsBox) {
    const tiles = $$('.fx-brand', brandsBox);
    tiles.sort((a, b) => items.filter((it) => it.marca.includes(b.dataset.fxVal)).length - items.filter((it) => it.marca.includes(a.dataset.fxVal)).length)
      .forEach((t) => brandsBox.appendChild(t));
    const more = panel.querySelector('[data-fx-more]');
    const search = panel.querySelector('[data-fx-brand-search]');
    let open = false;
    const layout = () => {
      const q = search ? search.value.trim().toLowerCase() : '';
      let i = 0;
      tiles.forEach((t) => {
        const hit = !q || (t.dataset.fxLabel || '').toLowerCase().includes(q);
        const pressed = t.getAttribute('aria-pressed') === 'true';
        t.hidden = !hit || (!q && !open && i >= 9 && !pressed);
        if (hit) i += 1;
      });
      if (more) {
        more.hidden = !!q;
        more.setAttribute('aria-expanded', open);
        more.textContent = open ? more.dataset.less : more.dataset.more;
      }
    };
    if (more) more.addEventListener('click', () => { open = !open; layout(); });
    if (search) search.addEventListener('input', layout);
    brandsBox.addEventListener('click', () => setTimeout(layout));
    layout();
  }

  const seriesBox = panel.querySelector('[data-fx-series]');
  const moreSeries = panel.querySelector('[data-fx-more-series]');
  if (seriesBox && moreSeries) {
    let open = false;
    const rows = $$('.fx-row', seriesBox);
    const layout = () => {
      rows.forEach((r, i) => { r.hidden = !open && i >= 6 && r.getAttribute('aria-pressed') !== 'true'; });
      moreSeries.setAttribute('aria-expanded', open);
      moreSeries.textContent = open ? moreSeries.dataset.less : moreSeries.dataset.more;
    };
    moreSeries.addEventListener('click', () => { open = !open; layout(); });
    layout();
  }

  const opener = root.querySelector('[data-fx-open]');
  const scrim = root.querySelector('.fx-scrim');
  const mq = window.matchMedia('(max-width: 960px)');
  const setOpen = (on) => {
    panel.toggleAttribute('data-open', on);
    if (scrim) scrim.hidden = !on;
    document.documentElement.classList.toggle('drawer-lock', on);
    if (opener) opener.setAttribute('aria-expanded', on);
    if (on) { const f = panel.querySelector('.fx-close'); if (f) f.focus(); } else if (opener && mq.matches) opener.focus();
  };
  if (opener) opener.addEventListener('click', () => setOpen(true));
  $$('[data-fx-close]', root).forEach((c) => c.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel.hasAttribute('data-open')) setOpen(false); });
  mq.addEventListener('change', () => { if (!mq.matches) setOpen(false); });

  render();
})();
